// extracted by mini-css-extract-plugin
module.exports = {"block":"Certifications_block__1yhFD","container":"Certifications_container__1YCAU"};